const dateTimePickers = () => {
  $('[data-type="time-only"]').datetimepicker({
    format: 'hh:mm A',
  });
  $('[data-type="time"]').datetimepicker({
    debug: false,
    format: 'HH:mm:ss',
  });
  $('[data-type="datetime"]').datetimepicker({
    debug: false,
    format: 'YYYY-MM-DD HH:mm:ss',
  });
  $('[data-type="date"]').datetimepicker({
    debug: false,
    format: 'YYYY-MM-DD',
  });
};

export default dateTimePickers;
